<template>
  <div class="c-datetime">
    <base-tooltip :text="tooltipText">
      <span v-if="diffInDays >= -1">{{$dayjs(date).fromNow()}}</span>
      <span v-else>{{$dayjs(date).format('DD/MM/YYYY')}}</span>
    </base-tooltip>
  </div>
</template>

<script>
export default {
  name: 'base-datetime',

  props: {
    date: String,
  },

  computed: {
    diffInDays() {
      return this.$dayjs(this.date).diff(this.$dayjs(new Date()), 'days');
    },

    tooltipText() {
      return this.$dayjs(this.date).format('ddd DD MMM YYYY HH:mm');
    },
  },
};
</script>

<style lang="scss">
.c-datetime {
  //
}
</style>

